import * as React from 'react';
const SvgChevroneKit = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" {...props}>
        <path
            d="M6.418 8.003l4.79 4.793a1 1 0 01-1.415 1.414l-5.496-5.5a1 1 0 010-1.414l5.496-5.5a1 1 0 111.415 1.414l-4.79 4.793z"
            fill="currentColor"
        />
    </svg>
);
export default SvgChevroneKit;
